import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';


const styles = {
  root: {
    position: 'fixed',
    zIndex: 999999,
    height: '2em',
    width: '2em',
    overflow: 'show',
    margin: 'auto',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    '&:before': {
      content: 'close-quote',
      display: 'block',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'radial-gradient(rgba(20, 20, 20, .8), rgba(0, 0, 0, .8))'
    }
  }
};

function FullScreenIndeterminate(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <CircularProgress color='primary' size={100} />
    </div>
  );
}

FullScreenIndeterminate.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FullScreenIndeterminate);


// WEBPACK FOOTER //
// ./src/components/Utils/FullScreenLoading.js